import { render, staticRenderFns } from "./ClientAccountingOverview.vue?vue&type=template&id=415234b6"
import script from "./ClientAccountingOverview.vue?vue&type=script&lang=js"
export * from "./ClientAccountingOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports